<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-icon left>mdi-robot</v-icon>
          <span>Claude Playground</span>
          <v-chip small outlined class="ml-3">Company: {{ companydb_id }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn small text @click="reload">
            <v-icon left>mdi-refresh</v-icon>
            Reload
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row>
      <!-- Preview -->
      <v-col cols="8">
        <v-card>
          <v-card-title class="py-2">Preview</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <DynamicComponentRenderer
              v-if="mounted"
              v-model="payload"
              :key="componentKey"
              :code="templateString"
              :schema="jsonSchema"
              :options="componentOptions"
              :company_id="companydb_id"
              @run_action="onAction"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Data Output -->
      <v-col cols="4">
        <v-card>
          <v-card-title class="py-2">
            Data
            <v-spacer></v-spacer>
            <v-btn x-small icon @click="copyData">
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <pre class="data-output">{{ JSON.stringify(payload, null, 2) }}</pre>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-card-title class="py-2">Actions Log</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div v-if="!actions.length" class="grey--text">No actions yet</div>
            <div v-for="(a, i) in actions" :key="i" class="mb-1">
              <v-chip small>{{ a }}</v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { fill_instance_from_schema } from "@/modules/entities/domain/GetTreeFromSchema";
import DynamicComponentRenderer from "@/modules/entities/infra/DynamicComponentRenderer.vue";
import * as PlaygroundEditor from "@/components/dynamic_factory/PlaygroundEditor.js";

export default {
  name: "ClaudeVibeComponentPlayground",
  components: { DynamicComponentRenderer },
  props: {
    companydb_id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      mounted: false,
      componentKey: 0,
      payload: {},
      actions: [],
      // Load from file
      jsonSchema: PlaygroundEditor.JSON_SCHEMA,
      templateString: PlaygroundEditor.TEMPLATE_STRING,
      componentOptions: PlaygroundEditor.COMPONENT_OPTIONS,
      initialData: PlaygroundEditor.INITIAL_DATA || {}
    }
  },
  mounted() {
    this.payload = fill_instance_from_schema(this.initialData, this.jsonSchema);
    this.mounted = true;
  },
  methods: {
    reload() {
      this.componentKey++;
      this.payload = fill_instance_from_schema(this.initialData, this.jsonSchema);
    },
    onAction(code) {
      this.actions.unshift(code);
    },
    copyData() {
      navigator.clipboard.writeText(JSON.stringify(this.payload, null, 2));
    }
  }
}
</script>

<style scoped>
.data-output {
  font-family: monospace;
  font-size: 12px;
  max-height: 400px;
  overflow: auto;
  background: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
}
</style>
